import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const Scholarships = () => {
  return (
    <PlaceholderPage title="Scholarships & Financial Aid">
      Discover the various scholarship opportunities and financial aid options available to help fund your education at FIC College.
    </PlaceholderPage>
  );
};

export default Scholarships;
